import { type ApprovalProposalListParams, ApprovalProposalListParamsSchema } from "@adpilot/shared";

export const DEFAULT_APPROVAL_SEARCH = ApprovalProposalListParamsSchema.parse({});

export function parseApprovalSearch(search: unknown): ApprovalProposalListParams {
  const parsed = ApprovalProposalListParamsSchema.safeParse(search);
  return parsed.success ? parsed.data : DEFAULT_APPROVAL_SEARCH;
}
